import { z } from 'zod';

export const GetFiatSupportedCountryListResultSchema = z.object({
  countries: z.array(z.string()),
  intermediate_bank_countries: z.array(z.string()),
});

export type GetFiatSupportedCountryListResult = z.infer<
  typeof GetFiatSupportedCountryListResultSchema
>;

export type GetFiatSupportedCountryListParams = string;
